import { types } from 'mobx-state-tree';
import { CriteriaResultModel } from './CriteriaResultModel';

export const CriteriaModel = types.model('CriteriaModel', {
  criteria: types.identifier,
  score: types.maybeNull(types.number),
  status: types.maybeNull(types.boolean),
  label: types.maybeNull(types.string),
  results: types.maybeNull(types.array(CriteriaResultModel)),
  altResult: types.maybeNull(types.string),
  shouldDisplayLabel: types.boolean,
  shouldDisplayResults: types.boolean,
  shouldDisplayAltResult: types.boolean,
});
